import React from 'react';

import { Link } from '@auspost/postmaster-react';

import Infotip from 'App/common/Tooltip/Infotip/infotip';
import { ReactComponent as CarbonNeutralIcon } from 'assets/carbon-neutral.svg';
import { ReactComponent as ParcelIcon } from 'assets/parcel.svg';
import { extLnkCarbonNeutral } from 'config/track-config';

import { useArticles, useShipment } from '../../hooks/shipment.hooks';
import { SERVICE_FEATURES_TEST_ID } from '../DetailsPanel.test-ids';

import styles from './ServiceFeatures.module.scss';

const ServiceFeatures: React.FC = () => {
  const carbonNeutral = useShipment()?.carbonNeutral ?? false;
  const articleType = useArticles()?.[0]?.articleType;

  const displayServices = () => {
    if (!articleType) return null;
    return (
      <div className={styles.row}>
        <ParcelIcon className={styles.serviceIcon} />
        <p className={styles.textContent}>{articleType}</p>
      </div>
    );
  };

  const displayFeatures = () => {
    if (!carbonNeutral) return null;
    return (
      <div className={styles.row}>
        <CarbonNeutralIcon className={styles.icon} />
        <p className={styles.textContent}>Carbon neutral delivery</p>
        <Infotip anchorClassName={styles.infotip}>
          <p>
            <span>This parcel was automatically sent carbon neutral. </span>
            <Link href={extLnkCarbonNeutral} className={styles.carbonNeutralLink}>
              Learn more
            </Link>
          </p>
        </Infotip>
      </div>
    );
  };

  return (
    <div className={styles.serviceFeatures} data-testid={SERVICE_FEATURES_TEST_ID}>
      {!articleType && !carbonNeutral ? (
        <p className={styles.textContent}>Not available</p>
      ) : (
        <>
          {displayServices()}
          {displayFeatures()}
        </>
      )}
    </div>
  );
};

export default ServiceFeatures;
